import PageHero from "@/components/PageHero";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const AuthorPromotion = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <PageHero
          eyebrow="Author Promotion"
          title={
            <>
              Get your book in front of{" "}
              <span className="text-gold">the right readers.</span>
            </>
          }
          intro="Author promotion services are coming soon. Soon you'll be able to amplify your reach, build your audience, and turn your book into a recognised brand."
        >
          <Button
            asChild
            className="bg-gold text-gold-foreground hover:bg-gold-light font-semibold"
          >
            <a
              href="https://meetings.series-a.co/meetings/series-a/authorpro"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book a Call
            </a>
          </Button>
          <Button asChild variant="outline">
            <a href="/">Back to Home</a>
          </Button>
        </PageHero>

        <section className="py-20 sm:py-28 border-b border-border">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 text-gold mb-8">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M12 20h9" />
                  <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                </svg>
              </div>
              <h2 className="text-2xl sm:text-3xl font-semibold mb-4">
                Coming soon
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed">
                We are building a suite of promotion tools and services to help
                authors launch, position, and grow their books. Check back soon
                or book a discovery call to be the first to hear when it goes
                live.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AuthorPromotion;
